import React, { useState, useEffect } from "react";
import { ResendNegotiation } from "../../../../services/CommonService";
import { toast } from "react-toastify";
import { FaTimes } from "react-icons/fa";

const ResendNegotiationModal = ({ show, onClose, negotiation }) => {
  const [recipients, setRecipients] = useState([]);

  // Load all recipients of selected negotiation
  useEffect(() => {
    if (negotiation?.recipients) {
      const formatted = negotiation.recipients.map((r) => ({
        id: r.id,
        recipient_id: r.recipient_id,
        first_name: r.first_name,
        last_name: r.last_name,
        email: r.email,
      }));
      setRecipients(formatted);
    }
  }, [negotiation]);

  // Remove recipient from list
  const removeRecipient = (id) => {
    setRecipients((prev) => prev.filter((r) => r.id !== id));
  };

  // Handle Resend
  const handleResend = async () => {
    if (!negotiation?.id) {
      toast.error("Negotiation ID missing!");
      return;
    }

    if (recipients.length === 0) {
      toast.error("At least one recipient is required!");
      return;
    }

    // Only remaining recipient_ids
    const ids = recipients.map((r) => r.recipient_id);

    try {
      const res = await ResendNegotiation({
        negotiation_id: negotiation.id,
        recipient_ids: ids,
      });

      toast.success(res?.data?.message || "Resent successfully!");
      onClose();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to resend!");
    }
  };

  if (!show) return null;

  return (
    <>

      <div className="custom-modal-backdrop"></div>

      <div className="modal fade show d-block" tabIndex="-1" id="ResendNegotiationModal">
        <div className="modal-dialog">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">Resend Negotiation</h5>
              <button type="button" className="btn-close" onClick={onClose}>
                <i className="bi bi-x-circle"></i>
              </button>
            </div>

            <div className="modal-body">

              {recipients.length > 0 ? (
                recipients.map((r) => (
                  <div
                    key={r.id}
                    className="d-flex align-items-center justify-content-between p-2 border rounded mb-2 shadow-sm"
                    style={{ background: "#f9f9f9", borderColor: "#ddd" }}
                  >
                    <div className="d-flex flex-column">
                      <strong className="text-dark" style={{ fontSize: "15px" }}>
                        {r.first_name} {r.last_name}
                      </strong>
                      <small className="text-muted" style={{ fontSize: "13px" }}>
                        {r.email}
                      </small>
                    </div>
                    <div>
                      <button
                        className="btn btn-sm text-danger"
                        style={{
                          background: "transparent",
                          fontSize: "20px",
                          lineHeight: "0",
                          fontWeight: "bold",
                          border: "none",
                        }}
                        onClick={() => removeRecipient(r.id)}
                      >
                        <FaTimes />
                      </button>
                    </div>
                  </div>

                ))
              ) : (
                <p className="text-danger">No recipients selected.</p>
              )}
            </div>

            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={onClose}>Close</button>
              <button className="btn btn-primary" onClick={handleResend}>Resend</button>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default ResendNegotiationModal;
